export default __webpack_public_path__ + "static/product-unit-13-tourism-2cb9ddde80a2e70b53e63905148be250.png";